import React from 'react';
import './FooterComponent.css';
import '../../App.css'
import {Box, Flex, Image, Link} from "@chakra-ui/react";

import instaIcon from '../../images/insta_icon.png'
import fbIcon from '../../images/fb_icon.png'
import logo from '../../images/logo.png'
import {useTranslation} from "react-i18next";
import {Link as RouteLink} from "react-router-dom";
import {animateScroll} from "react-scroll";

const FooterComponent = () => {
    const [t, i18n] = useTranslation('common');
    return (
        <Flex className="footer-grid">
            <Flex padding="0px" className="footer-grid-first-child" marginBottom="10px">
                <Link as={RouteLink} to="/" onClick={animateScroll.scrollToTop} margin="10px">
                    <Image
                        width="110px"
                        src={logo}
                        alt="Indie app"
                        objectFit="contain"
                    />
                </Link>
            </Flex>
            
            <Flex>
                    <Link flexShrink={0} href="privacy-policy"  marginRight="16px" marginLeft="16px">
                        <span className="footer-text">{t("Privacy policy")}</span>
                    </Link>
                    <Link flexShrink={0} href="terms-of-use"  marginRight="16px" marginLeft="16px">
                        <span className="footer-text">{t("Terms of use")}</span>
                    </Link>
            </Flex>

            <Box className="spacer" flex={1}/>

            <Flex marginRight="16px" marginLeft="16px" className="support-widget">
                <Box flexShrink={0} className="footer-title">{t("Contact us")}:</Box>
                <Link flexShrink={0} href="mailto:support@indie.ge" marginLeft="5px" target="_blank">
                    <span className="footer-text">support@indie.ge</span>
                </Link>
            </Flex>

            <Flex className="footer-grid-last-child">
                <Box textColor="#52537B" className="social-title" marginLeft="32px" marginRight="8px">
                    <span className="footer-title">{t("Follow us")}: </span>
                </Box>
                <Link href="https://www.instagram.com/indieappofficial/" target="_blank" marginRight="12px">
                    <Image
                        margin="5px"
                        width="24px"
                        src={instaIcon}
                        alt="Indie app"
                        objectFit="contain"
                    />
                </Link>
                <Link href="https://www.facebook.com/Indiemobileapp/" target="_blank">
                    <Image
                        margin="5px"
                        width="24px"
                        src={fbIcon}
                        alt="Indie app"
                        objectFit="contain"/>
                </Link>

            </Flex>
        </Flex>

    )

}
export default FooterComponent